module.exports = __webpack_public_path__ + "img/committee_character_success.d86c353d.png";